import { useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS, get } from '../../api/api';
import { logger } from '@/utils/logger';
import { CallList } from '@/pages/search/types.ts';
import { GuideList } from '@/pages/guide/HomePage2.tsx';

export const useSearchQuery = () => {
  return useQuery<CallList>({
    queryKey: ['search'],
    queryFn: async () => {
      const res = await get({ url: API_ENDPOINTS.search });
      // 여기 res가 axios response 객체라서  401 처리를 여기서 해도 되려나 고민중
      if (res.data.code === 'REQUIRED_0001') {
        logger.debug('약관 미동의 고객. 실험실 약관 동의 필요');
        throw new Error(res.data.message);
      }

      return res.data.data as CallList;
    },
  });
};

export const useDiscoverQuery = () => {
  return useQuery({
    queryKey: ['discover'],
    queryFn: async () => {
      const res = await get({ url: API_ENDPOINTS.discover });
      console.log(res);
      return res.data.data as GuideList;
    },
  });
};
